import types from './types'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    buildingList: []
  },

  getters: {
    buildingList: state => state.buildingList,
    buildingSelectorOptions: state => {
      let ret = []
      state.buildingList.forEach(item => {
        ret.push({
          value: item.id,
          label: item.name,
          children: Array.from(new Array(item.unit_count), (val, index) => {
            let unitValue = index + 1
            return {
              value: unitValue,
              label: `${unitValue}单元`,
              children: Array.from(new Array(item.floor_count), (val, index) => {
                let floorValue = index + 1
                return {
                  value: floorValue,
                  label: `${floorValue}层`
                }
              })
            }
          })
        })
      })
      return ret
    },
    buildingUnitOptions: state => {
      let ret = []
      state.buildingList.forEach(item => {
        ret.push({
          value: item.id,
          label: item.name,
          children: Array.from(new Array(item.unit_count), (val, index) => {
            let unitValue = index + 1
            return {
              value: unitValue,
              label: `${unitValue}单元`
            }
          })
        })
      })
      return ret
    }
  },

  mutations: {
    [types.SET_BUILDING_LIST](state, list) {
      state.buildingList = list
    },

    [types.ADD_BUILDING](state, building) {
      state.buildingList.unshift(building)
    },

    [types.UPDATE_BUILDING](state, building) {
      let index = state.buildingList.findIndex(item => item.id === building.id)
      state.buildingList[index] = building
    },

    [types.DELETE_BUILDING](state, id) {
      let index = state.buildingList.findIndex(item => item.id === id)
      state.buildingList.splice(index, 1)
    }
  },
  actions
}
